import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProviderSite } from '../../models';

@Component({
    selector: 'app-provider-site',
    templateUrl: './provider-site.component.html',
    styleUrls: ['./provider-site.component.scss'],
    standalone: false
})
export class ProviderSiteComponent {
    public sites: ProviderSite[] = [];

    public provider: any;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.sites = data.sites;
        this.provider = data;
    }
}
